import React, { useState, useContext } from 'react'
import { AuthUserContext, withAuthentication } from '../Session'
import { FirebaseContext } from '../../server/Firebase'
import { Table, Button, Form, Modal } from 'react-bootstrap'
//import * as ROLES from '../../constants/roles'
import {
  STUDENTSESSIONS,
  STUDENTSESSIONSLIST,
} from '../../constants/studentSession'
import uploadingGif from '../../imgs/uploading.gif'
import { AiOutlineCloudUpload, AiOutlineCloudDownload } from 'react-icons/ai'
import { BsFileEarmarkArrowDown, BsFileEarmarkPlus } from 'react-icons/bs'
import MeetingLink from '../MeetingLink'
import MiscVideoModal from '../MiscVideoModal'
import { ROOMS } from '../../constants/rooms'

const StudentDay = (props) => {
  const firebase = useContext(FirebaseContext)
  const presentations = STUDENTSESSIONSLIST['student']
  const fbPresentations = firebase.useTalks({ splinterGroup: 'student' })
  const meeting = firebase.useMiscMeeting({ session: 'student' })
  const user = useContext(AuthUserContext)
  return (
    <div>
      <h1 className='text-center py-3 text-5xl'>Student Day Schedule</h1>
      <h3 className='text-center py-3 text-3xl'>Sunday, June 22</h3>
      <h4
        className='text-center '
        // style={{
        //   display: 'flex',
        //   justifyContent: 'space-between',
        //   width: '30%',
        //   margin: 'auto',
        // }}
      >
        <a
          href='https://gem.epss.ucla.edu/mediawiki/index.php/GEM_Student_Forum'
          target='_blank'
          rel='noopener noreferrer'
          title='Student Wiki'
          className='text-blue-500 hover:text-red-500'
        >
          Wiki
        </a>
      </h4>

      <div className='flex justify-center pb-2'>
        {meeting?.link && (
          <p className='flex gap-2'>
            Join us remotely!{' '}
            {<MeetingLink link={meeting.link} info={meeting.linkInfo} />}
          </p>
        )}
        {user?.isAdmin && (
          <MiscVideoModal
            session='student'
            initialVideoLink={meeting?.link}
            initialVideoInfo={meeting?.linkInfo}
          />
        )}
      </div>
      <Table bordered hover size='lg'>
        <thead>
          <tr>
            <th width='125px'>CT</th>
            <th>Presentation</th>
            <th>Speaker</th>
            <th>Room</th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {presentations.flatMap((block) => (
            <Block
              block={block}
              fbPresentations={fbPresentations}
              firebase={props.firebase}
              key={block}
            />
          ))}
        </tbody>
      </Table>
    </div>
  )
}

const Block = ({ block, fbPresentations, firebase, ...props }) => {
  const presentations = block.map((id) => {

    return fbPresentations[id] || STUDENTSESSIONS[id]
  })
  if (presentations.length === 1) {
    let presentation = presentations[0]
    let row = (
      <tr key={presentation.id}>
        <td rowSpan={1}>
          {presentation.time}
          <h3>{/* <VideoLink url={'student/video'} /> */}</h3>
        </td>
        <td>{presentation.topicL || <strong>{presentation.name}</strong>}</td>
        <td>{presentation.presenter}</td>
        <td>{presentation.room && ROOMS[presentation.room].title}</td>
        <td>
          {presentation.presenter && (
            <UploadButton
              presentation={
                fbPresentations[presentation.name]
                  ? fbPresentations[presentation.name]
                  : presentation
              }
              firebase={firebase}
              block={block}
            />
          )}
        </td>
        <td>
          {fbPresentations[presentation.name] && (
            <a
              href={fbPresentations[presentation.name].url}
              target='_blank'
              rel='noopener noreferrer'
              download
              style={{ cursor: 'pointer' }}
              title='Download this presentation'
            >
              {<BsFileEarmarkArrowDown size='30px' />}
            </a>
          )}
        </td>
      </tr>
    )
    return row
  } else {
    const rows = []
    const headerRow = (
      <tr key={presentations[0].id + 'header'}>
        <td rowSpan={1}>{presentations[0].time}</td>
        <td>
          <strong>{presentations[0].name}</strong>
        </td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
    )
    rows.push(headerRow)
    for (let presentation of presentations) {
      let row = (
        <tr key={presentation.id}>
          <td rowSpan={1}></td>
          <td>{presentation.topicL || presentation.name}</td>
          <td>{presentation.presenter}</td>
          <td>{ROOMS[presentation.room].title}</td>
          <td>
            {presentation.presenter && (
              <UploadButton
                presentation={
                  fbPresentations[presentation.name]
                    ? fbPresentations[presentation.name]
                    : presentation
                }
                firebase={firebase}
                block={block}
              />
            )}
          </td>
          <td>
            {fbPresentations[presentation.name] && (
              <a
                href={fbPresentations[presentation.name].url}
                target='_blank'
                rel='noopener noreferrer'
                download
                style={{ cursor: 'pointer' }}
                title='Download this presentation'
              >
                {<BsFileEarmarkArrowDown size='30px' />}
              </a>
            )}
          </td>
        </tr>
      )
      rows.push(row)
    }
    return rows
  }
}

const DownloadButton = ({ url, ...props }) => {
  return (
    <a
      href={url}
      download
      target='_blank'
      rel='noopener noreferrer'
      title='Download'
    >
      {<AiOutlineCloudDownload size='30' />}
    </a>
  )
}

const UploadButton = ({ presentation }) => {
  const firebase = useContext(FirebaseContext)
  const [showModal, setShowModal] = useState(false)
  const [slides, setSlides] = useState(null)
  const [verify, setVerify] = useState(false)
  const [isUploading, setIsUploading] = useState(false)
  const handleToggle = () => setShowModal(!showModal)
  return (
    <div>
      <BsFileEarmarkPlus
        size='30'
        onClick={() => handleToggle()}
        title='Upload'
        style={{ cursor: 'pointer' }}
      />
      <Modal
        show={showModal}
        size='lg'
        aria-labelledby='contained-modal-title-vcenter'
        centered
        backdrop={true}
        onHide={handleToggle}
      >
        <Modal.Header closeButton>
          <Modal.Title id='contained-modal-title-vcenter'>
            Upload Poster Files
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={(e) => {
              e.preventDefault()
              setIsUploading(true)
              firebase.postStudentOrPlenaryTalk({
                group: 'student',
                data: presentation,
                file: slides,
                id: presentation.name,
              })
              setIsUploading(false)
              setShowModal(false)
            }}
          >
            <Form.Group controlId='verify'>
              <Form.Check
                id='verify'
                type='checkbox'
                checked={verify}
                onChange={() => setVerify(!verify)}
                label={`I confirm that I am ${presentation.presenter}.`}
              />
            </Form.Group>
            <Form.Group>
              <Form.Control
                type='file'
                id='posterFile'
                label='Please upload your presentation as a PDF. This will allow everyone to access and download this file.'
                onChange={(e) => setSlides(e.target.files[0])}
                accept='.pdf, .zip, .ppt, .pptx'
              />
            </Form.Group>
            You can reupload your files at any time. The files you had
            previously uploaded will be overwritten.
            <br />
            <br />
            <Button
              variant='primary'
              type='submit'
              disabled={!(verify && !!slides)}
            >
              Submit
            </Button>
            <img
              src={uploadingGif}
              style={{ display: isUploading ? '' : 'none' }}
              alt='Spinning circle around the word uploading'
            ></img>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  )
}

const condition = (authUser) => !!authUser

export default withAuthentication(StudentDay)
